// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-layout {
  min-height: 100vh;
  background: linear-gradient(135deg, #285C4D  0%, #285C4D 100%);
}

.app-header {
  background: linear-gradient(90deg, #6FC232 0%, #6FC232 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 0 24px;
  height: auto;
  line-height: normal;
}

.header-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0;
  text-align: center;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.logo-icon {
  font-size: 36px;
  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.3));
}

.app-content {
  padding: 24px;
  flex: 1 1;
}

.content-wrapper {
  max-width: 1400px;
  margin: 0 auto;
  height: calc(100vh - 140px);
}

.doctor-card,
.chat-card {
  height: 100%;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border: none;
  overflow: hidden;
}

.doctor-card {
  background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);
}

.chat-card {
  background: #ffffff;
}



/* 响应式设计 */
@media (max-width: 768px) {
  .app-content {
    padding: 16px;
  }
  
  .content-wrapper {
    height: calc(100vh - 120px);
  }
  
  .header-content {
    padding: 12px 0;
  }
  
  .logo-icon {
    font-size: 28px;
  }
  
  .doctor-card,
  .chat-card {
    margin-bottom: 16px;
  }
}

/* 动画效果 */
.doctor-card,
.chat-card {
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,8DAA8D;AAChE;;AAEA;EACE,4DAA4D;EAC5D,yCAAyC;EACzC,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA,UAAU;AACV;EACE;IACE,aAAa;EACf;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA,SAAS;AACT;;EAEE,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".app-layout {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #285C4D  0%, #285C4D 100%);\n}\n\n.app-header {\n  background: linear-gradient(90deg, #6FC232 0%, #6FC232 100%);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  padding: 0 24px;\n  height: auto;\n  line-height: normal;\n}\n\n.header-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 16px 0;\n  text-align: center;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.logo-icon {\n  font-size: 36px;\n  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.3));\n}\n\n.app-content {\n  padding: 24px;\n  flex: 1;\n}\n\n.content-wrapper {\n  max-width: 1400px;\n  margin: 0 auto;\n  height: calc(100vh - 140px);\n}\n\n.doctor-card,\n.chat-card {\n  height: 100%;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  border: none;\n  overflow: hidden;\n}\n\n.doctor-card {\n  background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);\n}\n\n.chat-card {\n  background: #ffffff;\n}\n\n\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .app-content {\n    padding: 16px;\n  }\n  \n  .content-wrapper {\n    height: calc(100vh - 120px);\n  }\n  \n  .header-content {\n    padding: 12px 0;\n  }\n  \n  .logo-icon {\n    font-size: 28px;\n  }\n  \n  .doctor-card,\n  .chat-card {\n    margin-bottom: 16px;\n  }\n}\n\n/* 动画效果 */\n.doctor-card,\n.chat-card {\n  animation: fadeInUp 0.6s ease-out;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
